export const BUILD_VERSION = '1788857215376';
